var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v(" mHero is not currently enabled. To enable it, update your configuration file. Visit the documentation on github for more information. ")])}
var staticRenderFns = []

export { render, staticRenderFns }